const ACCOUNT_TYPE = {
    LEAD: 'lead',
    CLEANER: 'cleaner',
    CLIENT: 'client',
    SA: 'sa'
};

export default ACCOUNT_TYPE;